import type { iconSizeMap } from '@wistia/vhs';
import { Icon, useThemeColor } from '@wistia/vhs';
import styled from 'styled-components';
import type { JSX } from 'react';

type SpinnerType = 'full-container' | 'full-page' | 'inline';

const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;

  &[data-type='full-page'] {
    min-height: 100vh;
  }

  &[data-type='full-container'] {
    min-height: 100%;
  }
`;

export const LoadingSpinner = ({
  type = 'full-page',
  size = 'lg',
  color,
}: {
  type?: SpinnerType;
  size?: keyof typeof iconSizeMap;
  color?: string;
}): JSX.Element => {
  const [grey700] = useThemeColor(['grey700']);

  return (
    <IconWrapper data-type={type}>
      <Icon
        size={size}
        color={color ?? grey700}
        type="spinner"
      />
    </IconWrapper>
  );
};
